/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import { getLogoutUrl, getLoginUrl } from '../../utility/common';

// eslint-disable-next-line react/jsx-props-no-spreading
const LogoutContainer = () => {
  const storeToken = useSelector((state) => state.saveToken);
  const cookie = new Cookies();
  useEffect(() => {
    const iToken = localStorage.getItem('id_token'); //cookie.get('id_token');
    const accesToken = localStorage.getItem('access_token');
    if (!iToken || !accesToken) {
      window.location.href = getLoginUrl();
    } else {
      const { idToken } = storeToken;
      const logOutUrl = getLogoutUrl(idToken);
      // const date = new Date();
      const userData = jwtDecode(idToken);
      // date.setTime(userData.exp * 1000);
      cookie.set('nonce', userData.nonce, { path: '/' });
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('id_token_expiry');
      //cookie.remove('id_token');
      window.location.href = logOutUrl;
    }
  }, []);

  return <div>Logging out...</div>;
};

export default LogoutContainer;
